import * as types from '../mutation-types'
import api from '@/api/highlightContent'

// initial state
const state = {
    highlightContent: [],
    loaded: false,
}

const getters = {
    highlightContent: (state) => {
        let keys = Object.keys(state.highlightContent);
        let values = Object.values(state.highlightContent).map((item, index) => {
            return item.map(elem => {
                return {...elem, ...{type: keys[index]}}
            })
        })
        let highlightContent = Array.prototype.concat.apply([], values);

        return  highlightContent.sort((a,b) => {
            return a._embedded.Content.orderHighlight - b._embedded.Content.orderHighlight
        })
    },
    highlightContentLoaded: state => state.loaded,
}

const actions = {
    getHighlightContent({ commit }) {
        commit(types.SET_HIGHLIGHT_CONTENT_LOADED, false );
        api.getHighlightContent({_embed: 1}, (response) => {
            let highlightContent = response.highlightContent
            delete highlightContent.customSections;
            commit(types.SET_HIGHLIGHT_CONTENT, highlightContent );
            commit(types.SET_HIGHLIGHT_CONTENT_LOADED, true );
        })
    },
    cleanHighlightContent({commit}) {
        commit(types.SET_HIGHLIGHT_CONTENT_LOADED, false );
        commit(types.SET_HIGHLIGHT_CONTENT, {} );
    }
}

const mutations = {
    [types.SET_HIGHLIGHT_CONTENT] (state, highlightContent ) {
        state.highlightContent = highlightContent
    },
    [types.SET_HIGHLIGHT_CONTENT_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


